import React from 'react';

import { WaCornerLogo, WaFooter } from '../whatsapp/layout/WaChrome';

const LoginPage = () => {
  /**
   * In 2026 BFF Pattern:
   * 1. REMOVED: useAuthContext and authService.
   * 2. REMOVED: useEffect redirect (ProtectedRoute now handles session verification).
   * 3. LOGIN: We redirect the browser to the Gateway's OAuth2 initiation path.
   */
  const handleLogin = () => {
    // This points to the standard Spring Security OAuth2 client initiation path on your Gateway
    window.location.href = `${process.env.REACT_APP_NOTIFICATION_SERVICE_APIGW_ENDPOINT}/oauth2/authorization/gateway-client`;
  };

  // The same corner logo (header) and footer as the WhatsApp pages, around the welcome in a framed card. No top bar: its buttons
  // (My User Profile, Logout, Dashboard) are for a signed-in user.
  return (
    <div className="wa-dashboard-page">
      <WaCornerLogo />
      <div className="wa-dashboard-inner">
        <main className="login-main">
          <section className="wa-dash-card login-card" aria-label="Log in">
            <h1 className="login-heading">Welcome to Primedha Connect</h1>
            <p>Please log in to continue</p>
            <button type="button" className="login-button" onClick={handleLogin}>
              Log In via Secure Gateway
            </button>
          </section>
        </main>

        <WaFooter />
      </div>
    </div>
  );
};

export default LoginPage;
